import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import {
  markActivity,
  setNextQuestion,
  startLoadingActivity
} from '../conquest/conquest.actions';
import css from './time-ticker-question.scss';
import { useTimer } from './time-ticker-question-hooks';
import { handInQtc } from '../mle/mle-actions';
import { ModalGeneric } from '../../components/modal-content';
import { constructModal, activateModal } from '../modal/modal-actions';
import { useLocalisation } from '../../helpers/i18n/use-localisation';
import { getValueFromUrl } from '../../helpers/utils';
import { TIMED_QUESTION_END_MARKER } from '../../helpers/constants';

const TimeTickerQuestion = ({
  className
}) => {
  const {
    timeLeftInSeconds,
    questions,
    isCompleted,
    questionIndex
  } = useSelector(state => state.mleReducer);
  const {
    isLoading,
    conquestUserAnswer,
    girlId
  } = useSelector(state => state.conquestReducer);
  const dispatch = useDispatch();
  const { i18n } = useLocalisation();
  const [tick, setTick] = useTimer(timeLeftInSeconds);

  const expirationModal = () => {
    dispatch(handInQtc());

    const modalData = {
      subHeader: i18n._(t`Great work!`),
      paragraph: i18n._(t`Your assessment has finished and been handed in.`),
      buttons: [
        {
          text: i18n._(t`OK`),
          callBack: () => dispatch(activateModal(false)),
          size: 'large'
        }
      ]
    };

    dispatch(constructModal({
      activate: true,
      content: <ModalGeneric modalData={modalData} />,
      canvasOnClick: false
    }));
  };

  const activityParams = {
    assignmentId: getValueFromUrl('assignmentId'),
    questionId: girlId,
    studentAnswer: conquestUserAnswer || undefined
  };

  useEffect(() => {
    if (tick === TIMED_QUESTION_END_MARKER && questionIndex === questions.length - 1) {
      dispatch(startLoadingActivity());
      dispatch(markActivity({
        ...activityParams,
        promiseResolved: () => expirationModal()
      }));
    } else if (tick === TIMED_QUESTION_END_MARKER) {
      dispatch(startLoadingActivity());
      dispatch(markActivity({
        ...activityParams,
        promiseResolved: () => dispatch(setNextQuestion({
          currentIndex: questionIndex,
          totalQuestions: questions.length
        }))
      }));
    }
  }, [tick]);

  useEffect(() => {
    if (!isLoading && !isCompleted) {
      setTick(timeLeftInSeconds);
    }
  }, [isLoading]);

  return (
    <div className={classNames(css['time-ticker'], className)}>
      {isCompleted ? '00:00' : tick}
    </div>
  );
};

TimeTickerQuestion.propTypes = {
  className: PropTypes.string
};

export default TimeTickerQuestion;
